// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.subcategories.new', {
        url: '/new',
        views: {
            "productView@product": {
                templateUrl: 'main/product/subcategories/subcategory/subcategory.tpl.html',
                controller: 'SubCategoryController as vm'
            }
        },
        resolve: {
            subCategory: function () { return {}; },
            mainGroups: mainGroupsResolver,
            intrastats: intrastatsResolver,
            createNew: function () { return true; }
        }
    });

    $stateProvider.state('product.subcategories.subcategory', {
        url: '/{subCategoryId}',
        views: {
            "productView@product": {
                templateUrl: 'main/product/subcategories/subcategory/subcategory.tpl.html',
                controller: 'SubCategoryController as vm'
            }
        },
        resolve: {
            subCategory: subCategoriesResolver,
            mainGroups: mainGroupsResolver,
            intrastats: intrastatsResolver,
            createNew: function () { return false; }
        }
    });

}


// @ngInject
function subCategoriesResolver($stateParams, SubCategoriesApiService) {
    return SubCategoriesApiService.getSubCategory($stateParams.subCategoryId);
}

// @ngInject
function mainGroupsResolver(SubCategoriesApiService) {
    return SubCategoriesApiService.getMaingroups();
}

// @ngInject
function intrastatsResolver(SubCategoriesApiService) {
    return SubCategoriesApiService.getIntrastats();
}
// @ngInject
function SubCategoryController($state, subCategory, mainGroups, intrastats, loadSpinnerService, createNew, SubCategoriesApiService, $scope, $translate, ToasterService) {
    var vm = this;

    //properties
    vm.subCategory = subCategory;
    vm.isNew = false;
    vm.isEditing = false;
    vm.mainGroups = mainGroups;
    vm.intrastats = intrastats;
    vm.subCategoryCopy = {};
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactSubCategoryView') !== 'false';
    vm.reactSubCategoryId = createNew ? null : (subCategory && subCategory.id != null ? subCategory.id : null);

    //functions
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.save = save;

    //initialize
    if (createNew) {
        vm.subCategory = { mainGroup: {} };
        vm.subCategory.mainGroup = angular.copy(vm.mainGroups[0]);
        vm.isNew = true;
        vm.isEditing = true;

    }

    function enableEditing() {
        vm.isEditing = true;
        vm.subCategoryCopy = angular.copy(vm.subCategory);
    }

    function cancelEditing() {
        vm.isEditing = false;
        vm.subCategory = vm.subCategoryCopy;
    }

    function save() {

        SubCategoriesApiService.save(vm.subCategory).then(function (result) {
            vm.subCategory.id = result.id;
            vm.isEditing = false;
            vm.isNew = false;
            ToasterService.showSuccess('"' + vm.subCategory.subCategoryCode + '" ' + $translate.instant("common.wasSaved"), $translate.instant("article.subcategory"));

        }, function (error) {
            ToasterService.showError(error.message, $translate.instant("article.subcategory"));
        }).finally(function () {
            $state.go('product.subcategories.subcategory', { subCategoryId: vm.subCategory.id });
        });
    }
}

angular
    .module('subcategories.subcategory', [])
    .config(stateConfig)
    .controller('SubCategoryController', SubCategoryController);

